/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_LOADING,
  SET_FORM_ACCOUNT_TAB_OTHER,
  SET_FORM_ACCOUNT_TAB_CAMPAIGNS,
  SET_CURRENT_NAVIGATION_TAB,
  SET_SHOULD_SCROLL_TO_PORT_PIN,
  GET_USER_INFO_BY_ID,
  GET_USER_INFO_BY_ID_ERROR,
  GET_USER_SUBSCRIPTION,
  GET_USER_SUBSCRIPTION_SUCCESS,
  GET_USER_SUBSCRIPTION_ERROR,
  SUBSCRIBE,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_ERROR,
  CANCEL_SUBSCRIPTION_AT_PERIOD_END,
  CANCEL_SUBSCRIPTION_AT_PERIOD_END_SUCCESS,
  CANCEL_SUBSCRIPTION_AT_PERIOD_END_ERROR,
  UNSUBSCRIBE,
  UNSUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_ERROR,
  UPDATE_SUBSCRIPTION_PAYMENT_METHOD,
  UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR,
  UPDATE_SUBSCRIPTION_PAYMENT_METHOD_SUCCESS,
  CREATE_REFERRAL_CODE,
  CREATE_REFERRAL_CODE_ERROR,
  CREATE_REFERRAL_CODE_SUCCESS,
  APPLY_REFERRAL_CODE,
  APPLY_REFERRAL_CODE_ERROR,
  APPLY_REFERRAL_CODE_SUCCESS,
  UPDATE_FILTERS,
  UPDATE_FILTERS_ERROR,
  UPDATE_FILTERS_SUCCESS,
  RETRIEVE_USER_SUBSCRIPTION,
  GET_USER_COMPANY_SETTINGS,
  GET_USER_COMPANY_SETTINGS_SUCCESS,
  GET_USER_COMPANY_SETTINGS_ERROR,
  GET_USER_CAMPAIGNS,
  GET_USER_CAMPAIGNS_SUCCESS,
  GET_USER_CAMPAIGNS_ERROR,
  SET_FILL_DEFAULT_VALUES,
  GET_AVAILABLE_REGIONS_LIST,
  GET_AVAILABLE_REGIONS_LIST_SUCCESS,
  GET_AVAILABLE_REGIONS_LIST_ERROR,
  GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION,
  GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_SUCCESS,
  GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_ERROR,
  CONFIRM_SELECTED_PHONE_NUMBER,
  CONFIRM_SELECTED_PHONE_NUMBER_SUCCESS,
  CONFIRM_SELECTED_PHONE_NUMBER_ERROR,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  GET_TCR_DETAILS,
  GET_TCR_DETAILS_SUCCESS,
  GET_TCR_DETAILS_ERROR,
  UPDATE_TCR_DETAILS,
  UPDATE_TCR_DETAILS_SUCCESS,
  UPDATE_TCR_DETAILS_ERROR,
  GET_PHONE_NUMBER_PORT_DETAILS,
  GET_PHONE_NUMBER_PORT_DETAILS_SUCCESS,
  GET_PHONE_NUMBER_PORT_DETAILS_ERROR,
  UPDATE_PHONE_NUMBER_PORT_DETAILS,
  UPDATE_PHONE_NUMBER_PORT_DETAILS_SUCCESS,
  UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR,
  SUBMIT_PHONE_NUMBER_PORT_REQUEST,
  SUBMIT_PHONE_NUMBER_PORT_REQUEST_SUCCESS,
  SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR,
  FINISH_PHONE_NUMBER_PORT,
  FINISH_PHONE_NUMBER_PORT_SUCCESS,
  FINISH_PHONE_NUMBER_PORT_ERROR,
} from 'src/actions/accountSettingsActions';

const formAccountTabOther = {
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const initialAccountSettings = {
  userSubscription: {},
  loadingUserSubscription: false,
};

const initialUserCampaigns = {
  loading: false,
  data: [],
};

const initialUserCompanySettings = {
  loading: false,
  data: {},
};

const initialCurrentNavigationTab = 'required';

const initialAvailableRegionsList = {
  loading: false,
  countries: [],
};

const initialAvailableNumbers = {
  loading: false,
  numbers: [],
  count: null,
};

const initialState = {
  accountSettings: initialAccountSettings,
  companyTitles: [],
  campaignSettings: [],
  loading: false,
  updatingFilters: false,
  formAccountTabOther,
  formAccountTabCampaigns: {},
  currentNavigationTab: initialCurrentNavigationTab,
  visibleModalFormNumber: null,
  // fillDefaultValues: false,
  fillDefaultValues: true,
  userCampaigns: initialUserCampaigns,
  userCompanySettings: initialUserCompanySettings,
  availableRegionsList: initialAvailableRegionsList,
  availableNumbers: initialAvailableNumbers,
  tcrDetailsFromBE: {},
  phoneNumberPortDetailsFromBE: {},
  phoneNumberPortDetailsFromBELoading: false,
  shouldScrollToPortPin: false,
};

const accountSettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING: {
      return produce(state, (draft) => {
        draft.loading = payload;
      });
    }

    case SET_FORM_ACCOUNT_TAB_OTHER: {
      return produce(state, (draft) => {
        draft.formAccountTabOther = payload ? {
          ...state.formAccountTabOther,
          ...payload,
        } : formAccountTabOther;
      });
    }

    case SET_FORM_ACCOUNT_TAB_CAMPAIGNS: {
      return produce(state, (draft) => {
        draft.formAccountTabCampaigns = payload ? {
          ...state.formAccountTabCampaigns,
          ...payload,
        } : {};
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialCurrentNavigationTab;
      });
    }

    case SET_SHOULD_SCROLL_TO_PORT_PIN: {
      return produce(state, (draft) => {
        draft.shouldScrollToPortPin = !!payload;
      });
    }

    case GET_USER_INFO_BY_ID: {
      return produce(state, (draft) => {
        const {
          accountSettings,
          companyTitles,
          campaignSettings,
        } = payload;
        draft.accountSettings = accountSettings;
        draft.companyTitles = companyTitles;
        draft.campaignSettings = campaignSettings;
        draft.loading = false;
      });
    }

    case GET_USER_INFO_BY_ID_ERROR: {
      return produce(state, (draft) => {
        const {
          accountSettings,
          companyTitles,
          campaignSettings,
        } = initialState;
        draft.accountSettings = accountSettings;
        draft.companyTitles = companyTitles;
        draft.campaignSettings = campaignSettings;
        draft.loading = false;
      });
    }

    case GET_USER_CAMPAIGNS: {
      return produce(state, (draft) => {
        draft.userCampaigns.loading = true;
      });
    }

    case GET_USER_CAMPAIGNS_SUCCESS: {
      return produce(state, (draft) => {
        draft.userCampaigns.loading = false;
        draft.userCampaigns.data = payload || [];
      });
    }

    case GET_USER_CAMPAIGNS_ERROR: {
      return produce(state, (draft) => {
        draft.userCampaigns.loading = false;
        draft.userCampaigns.data = [];
      });
    }

    case GET_USER_COMPANY_SETTINGS: {
      return produce(state, (draft) => {
        draft.userCompanySettings.loading = true;
      });
    }

    case GET_USER_COMPANY_SETTINGS_SUCCESS: {
      return produce(state, (draft) => {
        draft.userCompanySettings.loading = false;
        draft.userCompanySettings.data = payload || initialUserCompanySettings.data;
      });
    }

    case GET_USER_COMPANY_SETTINGS_ERROR: {
      return produce(state, (draft) => {
        draft.userCompanySettings.loading = false;
        draft.userCompanySettings.data = initialUserCompanySettings.data;
      });
    }

    case APPLY_REFERRAL_CODE:
    case CREATE_REFERRAL_CODE:
    case GET_USER_SUBSCRIPTION:
    case SUBSCRIBE:
    case UNSUBSCRIBE:
    case CANCEL_SUBSCRIPTION_AT_PERIOD_END:
    case UPDATE_SUBSCRIPTION_PAYMENT_METHOD: {
      return produce(state, (draft) => {
        draft.accountSettings.loadingUserSubscription = true;
      });
    }

    case APPLY_REFERRAL_CODE_SUCCESS:
    case CREATE_REFERRAL_CODE_SUCCESS:
    case GET_USER_SUBSCRIPTION_SUCCESS:
    case SUBSCRIBE_SUCCESS:
    case UNSUBSCRIBE_SUCCESS:
    case CANCEL_SUBSCRIPTION_AT_PERIOD_END_SUCCESS:
    case UPDATE_SUBSCRIPTION_PAYMENT_METHOD_SUCCESS: {
      return produce(state, (draft) => {
        draft.accountSettings.loadingUserSubscription = false;
        draft.accountSettings.userSubscription = payload ? {
          ...state?.accountSettings?.userSubscription || {},
          ...payload,
        } : initialState.accountSettings.userSubscription;
      });
    }

    case APPLY_REFERRAL_CODE_ERROR:
    case CREATE_REFERRAL_CODE_ERROR:
    case GET_USER_SUBSCRIPTION_ERROR:
    case SUBSCRIBE_ERROR:
    case UNSUBSCRIBE_ERROR:
    case CANCEL_SUBSCRIPTION_AT_PERIOD_END_ERROR:
    case UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR: {
      return produce(state, (draft) => {
        draft.accountSettings.loadingUserSubscription = false;
      });
    }

    case RETRIEVE_USER_SUBSCRIPTION: {
      return produce(state, (draft) => {
        draft.accountSettings.userSubscription = payload ? {
          ...state?.accountSettings?.userSubscription || {},
          ...payload,
        } : state?.accountSettings?.userSubscription || {};
      });
    }

    case SET_FILL_DEFAULT_VALUES: {
      return produce(state, (draft) => {
        draft.fillDefaultValues = payload;
      });
    }

    case UPDATE_FILTERS: {
      return produce(state, (draft) => {
        draft.accountSettings.updatingFilters = true;
      });
    }

    case UPDATE_FILTERS_ERROR:
    case UPDATE_FILTERS_SUCCESS: {
      return produce(state, (draft) => {
        draft.accountSettings.updatingFilters = false;
      });
    }

    case GET_AVAILABLE_REGIONS_LIST: {
      return produce(state, (draft) => {
        draft.availableRegionsList.loading = true;
      });
    }

    case GET_AVAILABLE_REGIONS_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.availableRegionsList.countries = payload?.countries || [];
        draft.availableRegionsList.loading = false;
      });
    }

    case GET_AVAILABLE_REGIONS_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.availableRegionsList = initialAvailableRegionsList;
      });
    }

    case GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION: {
      return produce(state, (draft) => {
        draft.availableNumbers.loading = true;
      });
    }

    case GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_SUCCESS: {
      return produce(state, (draft) => {
        draft.availableNumbers.numbers = payload?.numbers || [];
        draft.availableNumbers.count = payload?.count || 0;
        draft.availableNumbers.loading = false;
      });
    }

    case GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_ERROR: {
      return produce(state, (draft) => {
        draft.availableNumbers = initialAvailableNumbers;
      });
    }

    case CONFIRM_SELECTED_PHONE_NUMBER: {
      return produce(state, (draft) => {
        draft.availableNumbers.loading = true;
      });
    }

    case CONFIRM_SELECTED_PHONE_NUMBER_SUCCESS:
    case CONFIRM_SELECTED_PHONE_NUMBER_ERROR: {
      return produce(state, (draft) => {
        draft.availableNumbers.loading = false;
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    case GET_TCR_DETAILS: {
      return produce(state, (draft) => {
        draft.tcrDetailsFromBELoading = true;
      });
    }

    case GET_TCR_DETAILS_SUCCESS: {
      return produce(state, (draft) => {
        draft.tcrDetailsFromBELoading = false;
        draft.tcrDetailsFromBE = payload || {};
        // Store the opt-in method options separately for easy access
        if (payload?.optInMethodOptions) {
          draft.tcrOptInMethodOptions = payload.optInMethodOptions;
        }
      });
    }

    case GET_TCR_DETAILS_ERROR: {
      return produce(state, (draft) => {
        draft.tcrDetailsFromBELoading = false;
        draft.tcrDetailsFromBE = {};
      });
    }

    case UPDATE_TCR_DETAILS: {
      return produce(state, (draft) => {
        draft.tcrDetailsFromBELoading = true;
      });
    }

    case UPDATE_TCR_DETAILS_SUCCESS: {
      return produce(state, (draft) => {
        draft.tcrDetailsFromBELoading = false;
        // Optionally update the stored TCR details with the new data
        if (payload) {
          draft.tcrDetailsFromBE = {
            ...state.tcrDetailsFromBE,
            ...payload,
          };
        }
      });
    }

    case UPDATE_TCR_DETAILS_ERROR: {
      return produce(state, (draft) => {
        draft.tcrDetailsFromBELoading = false;
      });
    }

    case GET_PHONE_NUMBER_PORT_DETAILS: {
      return produce(state, (draft) => {
        draft.phoneNumberPortDetailsFromBELoading = true;
      });
    }

    case GET_PHONE_NUMBER_PORT_DETAILS_SUCCESS: {
      return produce(state, (draft) => {
        draft.phoneNumberPortDetailsFromBELoading = false;
        draft.phoneNumberPortDetailsFromBE = payload || {};
      });
    }

    case GET_PHONE_NUMBER_PORT_DETAILS_ERROR: {
      return produce(state, (draft) => {
        draft.phoneNumberPortDetailsFromBELoading = false;
        draft.phoneNumberPortDetailsFromBE = {};
      });
    }

    case UPDATE_PHONE_NUMBER_PORT_DETAILS:
    case SUBMIT_PHONE_NUMBER_PORT_REQUEST: {
      return produce(state, (draft) => {
        draft.phoneNumberPortDetailsFromBELoading = true;
      });
    }

    case UPDATE_PHONE_NUMBER_PORT_DETAILS_SUCCESS:
    case SUBMIT_PHONE_NUMBER_PORT_REQUEST_SUCCESS: {
      return produce(state, (draft) => {
        draft.phoneNumberPortDetailsFromBELoading = false;
        // Update the stored port details with the new data
        if (payload) {
          draft.phoneNumberPortDetailsFromBE = {
            ...state.phoneNumberPortDetailsFromBE,
            ...payload,
          };
        }
      });
    }

    case UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR:
    case SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR: {
      return produce(state, (draft) => {
        draft.phoneNumberPortDetailsFromBELoading = false;
      });
    }

    case FINISH_PHONE_NUMBER_PORT:
      return {
        ...state,
        loading: true,
      };

    case FINISH_PHONE_NUMBER_PORT_SUCCESS:
      return {
        ...state,
        loading: false,
        // Optionally update phoneNumberPortDetails if the response includes updated data
        phoneNumberPortDetails: action.payload.phoneNumberPortDetails || state.phoneNumberPortDetails,
      };

    case FINISH_PHONE_NUMBER_PORT_ERROR:
      return {
        ...state,
        loading: false,
      };

    default: {
      return state;
    }
  }
};

export default accountSettingsReducer;
